import { useState, useEffect } from 'react';
import camelCase from 'lodash/camelCase';
import zipObject from 'lodash/zipObject';

const buildURLQuery = (skus, vertical) => {
  const skusQuery = skus
    .map(sku => `skus[]=${encodeURIComponent(sku)}`)
    .join('&');
  return `${skusQuery}&vertical=${vertical}`;
};

const zipAttributes = attributes =>
  zipObject(
    attributes.map(attribute => camelCase(attribute.attribute_code)),
    attributes.map(attribute => attribute.value)
  );

const useFetchProductsBySku = (
  storeId,
  skus = [],
  vertical = process.env.RAZZLE_CMS_SITE
) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchOptions = {
    method: 'GET',
    credentials: 'include',
    headers: {
      accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  };

  const baseUrl = `${
    process.env.RAZZLE_MAGENTO_URL
  }/rest/${storeId}/V1/storefront`;

  async function fetchData(abortController) {
    try {
      const response = await fetch(
        `${baseUrl}/getproductsbysku?${buildURLQuery(skus, vertical)}`,
        { ...fetchOptions, signal: abortController.signal }
      );

      const json = await response.json();

      const products = json
        ? json.map(product => ({
            ...product,
            attributes: zipAttributes(product.custom_attributes)
          }))
        : [];

      setData(products);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  useEffect(
    () => {
      let abortController = null;
      if (storeId && skus && skus.length) {
        abortController = new AbortController();
        fetchData(abortController);
      } else {
        setLoading(false);
      }

      return () => {
        if (abortController) {
          abortController.abort();
        }
      };
    },
    [storeId, skus]
  );

  return { loading, data };
};

export default useFetchProductsBySku;
